module.exports = __webpack_public_path__ + "static/media/back.0632566c.png";